<script>
import axios from '@/utils/axios';
import { Modal } from 'bootstrap';
import { useShare } from '@/composables/useShare.js';
import { byDocumentType } from '@/utils/document-setting';

export default {
inject: ['setLoading'],
data() {
  return {
    tableColumns: [
      { key: 'checkbox', label: '', width: '40px' },
      { key: 'quotation_no', label: 'Quotation No' },
      { key: 'subject', label: 'Subject' },
      { key: 'to_name', label: 'To' },
      { key: 'total', label: 'Total' },
      { key: 'created_at', label: 'Created At' },
      { key: 'status', label: 'Status' },
      { key: 'assigned', label: 'Assigned' },
      { key: 'actions', label: 'Actions' },
    ],
    priceReviewRow: null,
    priceReviewItems: [],
    priceReviewLoading: false,
    priceReviewError: null,
    title: "Sales",
    text: "Sales",
    app_currency: '',
    data: [],
    type: 'quotation',
    setting: [],
    pagination: {
     current_page: 1,
     per_page: 25,
     last_page: 1,
     total: 0,
     links: []
    },
    status: '',
    search_keyword: '',
    selected_rows: [],
    status_data: [],
  };
},

 computed: {
  // serialNo(){
  //  return (this.pagination.current_page - 1) * this.pagination.per_page;
  // },
  text1(){
   return `Quotations (${this.pagination.total})`; 
  },
  allSelected() {
   return this.data?.length && this.selected_rows.length === this.data.length;
  }
 },
 async mounted() { 
  const { shareContent } = useShare();
  this.shareContent = shareContent; 
  this.loadAll();
 }, 

 methods: {

async openPriceReview(row) {
  this.priceReviewRow = row;
  this.priceReviewItems = [];
  this.priceReviewError = null;
  this.priceReviewLoading = true;

  const modalEl = document.getElementById('price_review_modal');
  let modal = Modal.getInstance(modalEl);
  if (!modal) modal = new Modal(modalEl);
  modal.show();

  try {
    
    const response = await axios.get(`/quotations/${row.public_token}`);
    const data = response.data.data;
   
    this.priceReviewItems = data.quotation_items.map(qi => ({
      name: qi.name,
      hsn_code: qi.hsn_code,
      unit: qi.unit,
      qty: parseFloat(qi.quantity),
      base_price: parseFloat(qi.item?.price || 0),      
      quoted_price: parseFloat(qi.unit_price || 0),       
      tax_name: qi.tax?.name || '—',
      amount: parseFloat(qi.total || 0),
    }));
  } catch (e) {
    this.priceReviewError = 'Failed to load quotation details.';
  } finally {
    this.priceReviewLoading = false;
  }
},

async approveQuotation() {
  const result = await this.$confirm({});
  if (result.isConfirmed) {
    this.setLoading(true);
    try {
      const response = await axios.patch(`/quotations/${this.priceReviewRow.id}/action`, {
        action: 'approve'
      });
      this.$swalToast(response.data.message);
      const modalEl = document.getElementById('price_review_modal');
      const modal = Modal.getInstance(modalEl);
      if (modal) modal.hide();
      this.loadAll();
    } catch (error) {
      this.$swalToast(error.message, 'error');
    } finally {
      this.setLoading(false);
    }
  }
},

async rejectQuotation() {
  const result = await this.$confirm({});
  if (result.isConfirmed) {
    this.setLoading(true);
    try {
      const response = await axios.patch(`/quotations/${this.priceReviewRow.id}/action`, {
        action: 'reject'
      });
      this.$swalToast(response.data.message);
      const modalEl = document.getElementById('price_review_modal');
      const modal = Modal.getInstance(modalEl);
      if (modal) modal.hide();
      this.loadAll();
    } catch (error) {
      this.$swalToast(error.message, 'error');
    } finally {
      this.setLoading(false);
    }
  }
},

  async selectStatus(status){
   this.status = status;
   await this.quotations();
  },

  async shareQuotation(row){
   const shareUrl = `/sales/quotations/view/${row.public_token}`
   const result = await this.shareContent(
    `Quotation ${row.quotation_number}`,
    `Quotation #${row.quotation_number} - ${row.party?.name || 'Client'}`, shareUrl);
  },

  handleToggleAll(event) {
   this.selected_rows = this.$toggleAll(event, this.data);
  },

  async loadAll(){
   this.quotations();
   this.statusData();
   this.byType(this.type);
   this.app_currency = await this.$appCurrency();
  },

  async byType(type){
   this.setLoading(true);
   try{
    const response = await byDocumentType(type, this.clientAdmin?.id);
    this.setting = response.data.data;
   }catch(error){
    this.$swalToast(error.message, 'error');
   }finally{
    this.setLoading(false);
   }
  },

  async statusData(){
   try{
    const response = await axios.get(`/quotations/status-wise/data`);
    this.status_data = response.data.data;
   }catch(error){
    this.$swalToast(error.message, 'error');
   }
  },

  async viewPDF(id){
   try{
    const response = await axios.get(`/quotations/${id}/pdf`,{
     responseType: 'blob' 
    });

    const file = new Blob([response.data], { type: 'application/pdf' });
    const fileURL = URL.createObjectURL(file);
  
    window.open(fileURL, '_blank');
   }catch(error){
    this.$swalToast("Failed to open PDF", 'error');
    console.error(error);
   }
  },

  async quotations(page = 1){
   this.setLoading(true);
   try{
    const params = {
     page,
     status: this.status || '',
     search_keyword: this.search_keyword.trim() || ''
    };
    const query_string = new URLSearchParams(params).toString();
    const response = await axios.get(`/quotations?${query_string}`);
    this.data = response.data.data.data;
    this.pagination = {
      current_page: response.data.data.current_page,
      per_page: response.data.data.per_page,
      last_page: response.data.data.last_page,
      total: response.data.data.total,
      links: response.data.data.links
    };
   }catch(error){
    this.$swalToast(error.message, 'error');
   }finally{
    this.setLoading(false);
   }
  },

  // changePage(url) {
  //  if (!url) return;
  //  const page = new URL(url).searchParams.get("page");
  //  this.quotations(page);
  // },

  bulkAction(){
   if(this.selected_rows.length){
    this.$refs.quotationModal.bulkAction(this.selected_rows); 
    const modalEl = document.getElementById("bulk_action_quotation");
    let modal = Modal.getInstance(modalEl);
    if(!modal){ modal = new Modal(modalEl);}
    modal.show();
   }else{
    this.$swalToast("Please select at least one option.", 'warning');
   }
  }, 

  clearFilter(){
   this.status = '';
   this.search_keyword = '';
   this.quotations();
  },

},
};
</script>

<template>
<layout-header></layout-header>
<layout-sidebar></layout-sidebar>

<!-- Page Wrapper -->
<div class="page-wrapper">
<div class="content">
  <!-- Breadcrumb -->
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <breadcrumb :title="title" :text="text" :text1="text1" />
    <div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
      
      <div class="me-2 mb-2">
      <button type="button" class="btn btn-outline-secondary" @click="bulkAction();"><i class="ti ti-playstation-square me-1"></i> Bulk Actions</button> 
      </div>
      
      <div class="mb-2">
        <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#quotation_modal" class="btn btn-primary d-flex align-items-center" @click="$refs.quotationModal.add();">
          <i class="ti ti-circle-plus me-2"></i>Add Quotation
        </a>
      </div>
      
    </div>
  </div>
  <!-- /Breadcrumb -->

  <div class="row">

   <div class="col-md-3 cursor-pointer" v-for="(row, index) in status_data" :key="index" @click="selectStatus(row.status);">
    <div class="card flex-fill">
    <div class="card-body">
    <div class="d-flex align-items-center overflow-hidden mb-2">
    <div>
      <p class="fs-12 fw-normal mb-1 text-truncate">{{row.status}}</p>
      <h5>{{app_currency.code}} {{row.amount}}</h5>
    </div>
    </div>
    <div class="attendance-report-bar mb-2">
    <div class="progress" role="progressbar" aria-label="Success example" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" style="height: 5px;">
      <div :class="`progress-bar ${row.bg_color}`" :style="`width: ${row.percentage}%;`"></div>
    </div>
    </div>
    <div>
    <p class="fs-12 fw-normal d-flex align-items-center text-truncate"><span class="text-muted fs-12 d-flex align-items-center me-1">Total: {{row.count}}</span></p>
    </div>
    </div>
    </div>
   </div> 

  </div>

  <div class="card">
  <div class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
  <h5>Quotations List</h5>
  <div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
    
    <div class="me-3" v-if="search_keyword !== '' || status !== '' ">
     <a href="javascript:void(0);" class="text-danger" @click="clearFilter()"><i class="ti ti-filter-x"></i></a>
    </div>  
    
    <div class="me-3">
     <select class="form-select" v-model="status" @change="quotations">
      <option value="">Status</option>
      <option value="Draft">Draft</option>
      <option value="Sent">Sent</option>
      <option value="Accepted">Accepted</option>
      <option value="Rejected">Rejected</option>
     </select>
    </div>

    <div class="me-3">
    <div class="input-icon-end position-relative">
     <input type="text" class="form-control" v-model="search_keyword" placeholder="Search...."/>
    </div>
    </div>

    <div class="me-3">
     <button type="button" class="btn btn-dark" @click="quotations()"><i class="ti ti-search"></i></button>
    </div>

    </div>
</div>
<div class="card-body card-table-wrapper">
<app-table
    :columns="tableColumns"
    :rows="data"
    :pagination="pagination"
    :loading="false"
    empty-text="No records found."
    empty-icon="ti ti-file-off"
    @page-change="quotations"
  >

    <!-- Checkbox Header -->
    <template #header-checkbox>
      <div class="form-check form-checkbox-success mb-2">
        <input type="checkbox" class="form-check-input" :checked="allSelected" @change="handleToggleAll">
      </div>
    </template>

    <!-- Checkbox -->
    <template #checkbox="{ row }">
      <div class="form-check form-checkbox-success mb-2">
        <input type="checkbox" class="form-check-input" :value="row.id" v-model="selected_rows">
      </div>
    </template>

    <!-- Quotation No -->
    <template #quotation_no="{ row }">
      <a :href="`/sales/quotations/view/${row.public_token}`" target="_blank" class="text-primary">{{ row.quotation_number }}</a>
    </template>

    <!-- Total -->
    <template #total="{ row }">
      {{ row.party?.currency?.symbol+row.total }}
    </template>

    <!-- Created At -->
    <template #created_at="{ row }">
      {{ $formatDate(row.created_at) }}
    </template>

    <!-- Status -->
    <template #status="{ row }">
      <div style="display:flex;flex-direction:column;align-items:flex-start;gap:5px;">
        <span class="badge rounded-pill bg-outline-secondary">{{ row.status }}</span>
        <button v-if="row.status === 'Pending' && auth?.type === 'ADMIN'"
          type="button"
          @click="openPriceReview(row)"
          style="display:inline-flex;align-items:center;gap:4px;padding:3px 9px;background:#fff7ed;border:1px solid #fed7aa;border-radius:20px;color:#c2410c;font-size:10.5px;font-weight:600;cursor:pointer;white-space:nowrap;">
          <svg width="10" height="10" viewBox="0 0 16 16" fill="none" style="flex-shrink:0;">
            <path d="M2 8h3l2-5 3 10 2-5h2" stroke="#c2410c" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          Price Review
        </button>
      </div>
    </template>

    <!-- Assigned -->
        <template #assigned="{ row }">
      <img :src="row.user?.image_url || $profileImage(null, clientAdmin)" width="22" /> {{ row.user?.name }}
    </template>

    <!-- action -->
    <template #actions="{ row }">
  <div class="dropdown">
    <button class="btn btn-icon btn-sm rounded-circle" type="button" 
            data-bs-toggle="dropdown" aria-expanded="false">
      <i class="ti ti-dots-vertical"></i>
    </button>
    <ul class="dropdown-menu dropdown-menu-end p-3">

      <template v-if="(row.status !== 'Pending' && row.status !== 'Price_Rejected') || auth?.type === 'ADMIN'">
        <li>
          <a class="dropdown-item rounded-1" href="javascript:void(0);" 
             data-bs-toggle="modal" data-bs-target="#quotation_modal" 
             @click="$refs.quotationModal.editQuotation(row.public_token)">
            <i class="ti ti-edit me-1"></i>Edit
          </a>
        </li>
        <li v-if="row.status !== 'Accepted' && row.status !== 'Rejected'">
          <a class="dropdown-item rounded-1" href="javascript:void(0);" 
             data-bs-toggle="modal" data-bs-target="#quotation_assign_modal" 
             @click="$refs.quotationModal.assignHistory(row.id, row.quotation_number)">
            <i class="ti ti-user-star me-1"></i>Assign User
          </a>
        </li>
        <li>
          <a class="dropdown-item rounded-1" href="javascript:void(0);" 
             @click="viewPDF(row.id)">
            <i class="ti ti-file-type-pdf me-1"></i>View PDF
          </a>
        </li>
        <li>
          <a class="dropdown-item rounded-1" href="javascript:void(0);" 
             @click="shareQuotation(row)">
            <i class="ti ti-share me-1"></i>Share Quotation
          </a>
        </li>
        <li v-if="setting?.send_on_email && row.status !== 'Accepted'">
          <a class="dropdown-item rounded-1" href="javascript:void(0);" 
             data-bs-toggle="modal" data-bs-target="#quotation_mail_modal" 
             @click="$refs.quotationModal.mailQuotation(row)">
            <i class="ti ti-mail me-1"></i>Send on Email
          </a>
        </li>
        <li>
          <a class="dropdown-item rounded-1" href="javascript:void(0);" 
             data-bs-toggle="modal" data-bs-target="#proforma_invoice_modal" 
             @click="$refs.proformaInvoiceModal.generateByQuotation(row.public_token)">
            <i class="ti ti-file-text me-1"></i>Generate Proforma
          </a>
        </li>
        <li>
          <a class="dropdown-item rounded-1 text-danger" href="javascript:void(0);" 
             data-bs-toggle="modal" data-bs-target="#quotation_delete_modal" 
             @click="$refs.quotationModal.editQuotation(row.public_token)">
            <i class="ti ti-trash me-1"></i>Delete
          </a>
        </li>
      </template>

      <!-- Activity  -->
      <li>
        <a class="dropdown-item rounded-1" href="javascript:void(0);" 
           data-bs-toggle="modal" data-bs-target="#quotation_activity_modal" 
           @click="$refs.quotationModal.activity(row.id)">
          <i class="ti ti-activity me-1"></i>Activity
        </a>
      </li>

    </ul>
  </div>
</template>

  </app-table>
</div>
</div>
</div>

<app-footer></app-footer>

</div>
<!-- /Page Wrapper -->

<quotation-modal ref="quotationModal" @updated="loadAll"></quotation-modal>
<proforma-invoice-modal ref="proformaInvoiceModal"></proforma-invoice-modal>



<!-- ═══════════════════════════════════════════════
     PRICE REVIEW MODAL
═══════════════════════════════════════════════ -->
<div class="modal fade" id="price_review_modal" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered modal-xl">
    <div class="modal-content" style="border:none;border-radius:16px;overflow:hidden;">

      <!-- Header -->
      <div style="background:#0f172a;padding:16px 22px;display:flex;align-items:center;justify-content:space-between;">
        <div style="display:flex;align-items:center;gap:11px;">
          <div style="width:34px;height:34px;background:rgba(255,255,255,0.08);border-radius:8px;display:flex;align-items:center;justify-content:center;flex-shrink:0;">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M2 8h3l2-5 3 10 2-5h2" stroke="#93c5fd" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div>
            <div style="font-size:14px;font-weight:500;color:#fff;">Price Review</div>
            <div style="font-size:11px;color:#fff;margin-top:1px;">
              {{ priceReviewRow?.quotation_number }} — {{ priceReviewRow?.to_name }}
            </div>
          </div>
        </div>
        <button type="button" data-bs-dismiss="modal"
          style="width:28px;height:28px;background:rgba(255,255,255,0.08);border:none;border-radius:6px;display:flex;align-items:center;justify-content:center;cursor:pointer;">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M1 1l10 10M11 1L1 11" stroke="#94a3b8" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </button>
      </div>

      <!-- Body -->
      <div style="padding:20px;background:#f8fafc;">

        <!-- Loading -->
        <div v-if="priceReviewLoading"
          style="text-align:center;padding:50px;color:#94a3b8;background:#fff;border-radius:12px;">
          <div style="font-size:22px;margin-bottom:8px;">⏳</div>
          <div style="font-size:13px;">Loading price details...</div>
        </div>

        <!-- Error -->
        <div v-else-if="priceReviewError"
          style="text-align:center;padding:40px;color:#f43f5e;background:#fff;border-radius:12px;font-size:13px;">
          {{ priceReviewError }}
        </div>

        <template v-else>

          <!-- Info banner -->
          <div style="background:#fffbeb;border:1px solid #fde68a;border-radius:10px;padding:10px 14px;margin-bottom:16px;display:flex;align-items:flex-start;gap:9px;">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" style="flex-shrink:0;margin-top:1px;">
              <circle cx="7" cy="7" r="6" stroke="#f59e0b" stroke-width="1.4"/>
              <path d="M7 4.5v3M7 9.5h.01" stroke="#f59e0b" stroke-width="1.4" stroke-linecap="round"/>
            </svg>
            <span style="font-size:12px;color:#92400e;line-height:1.5;">
              Item-wise <strong>Base Price (MRP)</strong> vs <strong>Quoted Price</strong> comparison.
              Rows highlighted in orange indicate a price change made by the user.
            </span>
          </div>

          <!-- Table card -->
          <div style="background:#fff;border-radius:12px;border:0.5px solid #e2e8f0;overflow:hidden;margin-bottom:14px;">
            <div class="table-responsive">
              <table style="width:100%;border-collapse:collapse;font-size:12px;">
                <thead>
                  <tr style="background:#1e293b;">
                    <th style="padding:10px 13px;color:#fff;font-weight:600;font-size:11px;text-align:left;width:32px;">#</th>
                    <th style="padding:10px 13px;color:#fff;font-weight:600;font-size:11px;text-align:left;">Item</th>
                    <th style="padding:10px 13px;color:#fff;font-weight:600;font-size:11px;text-align:left;">HSN</th>
                    <th style="padding:10px 13px;color:#fff;font-weight:600;font-size:11px;text-align:left;">Unit</th>
                    <th style="padding:10px 13px;color:#fff;font-weight:600;font-size:11px;text-align:center;">Qty</th>
                    <th style="padding:10px 13px;color:#fff;font-weight:600;font-size:11px;text-align:right;white-space:nowrap;">Base Price (MRP)</th>
                    <th style="padding:10px 13px;color:#fff;font-weight:600;font-size:11px;text-align:right;white-space:nowrap;">Quoted Price</th>
                    <th style="padding:10px 13px;color:#fff;font-weight:600;font-size:11px;text-align:center;">Difference</th>
                    <th style="padding:10px 13px;color:#fff;font-weight:600;font-size:11px;text-align:left;">Tax</th>
                    <th style="padding:10px 13px;color:#fff;font-weight:600;font-size:11px;text-align:right;">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, i) in priceReviewItems" :key="i"
                    :style="item.quoted_price !== item.base_price
                      ? 'background:#fff7ed;border-left:3px solid #f97316;border-bottom:1px solid #f1f5f9;'
                      : 'border-left:3px solid transparent;border-bottom:1px solid #f1f5f9;'">
                    <td style="padding:11px 13px;color:#94a3b8;">{{ i + 1 }}</td>
                    <td style="padding:11px 13px;font-weight:600;color:#0f172a;font-size:12.5px;">{{ item.name }}</td>
                    <td style="padding:11px 13px;color:#64748b;">{{ item.hsn_code || '—' }}</td>
                    <td style="padding:11px 13px;color:#64748b;">{{ item.unit || '—' }}</td>
                    <td style="padding:11px 13px;text-align:center;font-weight:500;color:#1e293b;">{{ item.qty }}</td>
                    <td style="padding:11px 13px;text-align:right;">
                      <span style="font-weight:600;color:#16a34a;">
                        {{ app_currency.symbol || '₹' }}{{ item.base_price.toFixed(2) }}
                      </span>
                    </td>
                    <td style="padding:11px 13px;text-align:right;">
                      <span :style="item.quoted_price < item.base_price
                        ? 'font-weight:700;color:#ea580c;'
                        : item.quoted_price > item.base_price
                          ? 'font-weight:700;color:#2563eb;'
                          : 'font-weight:600;color:#16a34a;'">
                        {{ app_currency.symbol || '₹' }}{{ item.quoted_price.toFixed(2) }}
                      </span>
                    </td>
                    <td style="padding:11px 13px;text-align:center;">
                      <template v-if="item.quoted_price !== item.base_price">
                        <span :style="(item.quoted_price - item.base_price) < 0
                          ? 'background:#fff7ed;color:#c2410c;padding:2px 9px;border-radius:20px;font-size:11px;font-weight:700;border:1px solid #fed7aa;display:inline-block;'
                          : 'background:#eff6ff;color:#1d4ed8;padding:2px 9px;border-radius:20px;font-size:11px;font-weight:700;border:1px solid #bfdbfe;display:inline-block;'">
                          {{ (item.quoted_price - item.base_price) > 0 ? '+' : '' }}{{ app_currency.symbol || '₹' }}{{ Math.abs(item.quoted_price - item.base_price).toFixed(2) }}
                        </span>
                      </template>
                      <span v-else style="font-size:11px;color:#94a3b8;">No change</span>
                    </td>
                    <td style="padding:11px 13px;color:#64748b;">{{ item.tax_name }}</td>
                    <td style="padding:11px 13px;text-align:right;font-weight:700;color:#0f172a;">
                      {{ app_currency.symbol || '₹' }}{{ item.amount.toFixed(2) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Summary strip -->
          <div style="display:grid;grid-template-columns:1fr 1fr 1.6fr;gap:10px;">

            <div style="background:#f0fdf4;border:1px solid #bbf7d0;border-radius:10px;padding:13px 16px;">
              <div style="font-size:11px;font-weight:600;color:#16a34a;margin-bottom:4px;">Total Items</div>
              <div style="font-size:22px;font-weight:800;color:#166534;">{{ priceReviewItems.length }}</div>
            </div>

            <div style="background:#fff7ed;border:1px solid #fed7aa;border-radius:10px;padding:13px 16px;">
              <div style="font-size:11px;font-weight:600;color:#ea580c;margin-bottom:4px;">Price Changed</div>
              <div style="font-size:22px;font-weight:800;color:#9a3412;">
                {{ priceReviewItems.filter(x => x.quoted_price !== x.base_price).length }}
              </div>
            </div>

            <div style="background:#0f172a;border-radius:10px;padding:13px 20px;display:flex;align-items:center;justify-content:space-between;">
              <div>
                <div style="font-size:12px;font-weight:500;color:#93c5fd;">Grand Total</div>
                <div style="font-size:11px;color:#fff;margin-top:2px;">Incl. all taxes</div>
              </div>
              <div style="font-size:24px;font-weight:800;color:#fff;letter-spacing:-0.5px;">
                {{ app_currency.symbol || '₹' }}{{ priceReviewItems.reduce((s, x) => s + x.amount, 0).toFixed(2) }}
              </div>
            </div>

          </div>

        </template>
      </div>

      <!-- Footer -->
      <div style="background:#fff;border-top:0.5px solid #e2e8f0;padding:13px 22px;display:flex;align-items:center;justify-content:space-between;">
        <button type="button" data-bs-dismiss="modal"
          style="padding:7px 18px;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;font-size:12.5px;font-weight:600;color:#475569;cursor:pointer;">
          Close
        </button>
        <div style="display:flex;gap:10px;">
          <button type="button" @click="rejectQuotation"
            style="display:inline-flex;align-items:center;gap:6px;padding:8px 20px;background:#fff0f3;border:1.5px solid #fecdd3;border-radius:9px;color:#f43f5e;font-size:12.5px;font-weight:700;cursor:pointer;">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
              <path d="M1.5 1.5l9 9M10.5 1.5l-9 9" stroke="#f43f5e" stroke-width="1.8" stroke-linecap="round"/>
            </svg>
            Reject
          </button>
          <button type="button" @click="approveQuotation"
            style="display:inline-flex;align-items:center;gap:6px;padding:8px 22px;background:#16a34a;border:none;border-radius:9px;color:#fff;font-size:12.5px;font-weight:700;cursor:pointer;box-shadow:0 2px 8px rgba(22,163,74,.3);">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
              <path d="M1.5 6l3.5 3.5 5.5-7" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            Approve
          </button>
        </div>
      </div>

    </div>
  </div>
</div>
</template>
<style scoped>
.table-responsive {
    overflow-y: scroll;
}
</style>